{
  "schema_version": 1,
  "task_id": "TAURI-DESKTOP-SHELL-SOURCE-READONLY-PROBE-001",
  "source_mode": "bounded-public-source-metadata-readonly-receipt",
  "formal_authority": false,
  "generated_at_utc": "2026-07-29T20:00:57.832Z",
  "runtime_mode": "live-public-source-metadata-readonly",
  "live_network_default_enabled": false,
  "live_network_performed": true,
  "authority_boundary": {
    "authority": "bounded-public-source-metadata-readonly-probe",
    "public_network_get_head_allowed": true,
    "live_network_default_enabled": false,
    "account_access": false,
    "authenticated_access": false,
    "user_credentials": false,
    "github_clone": false,
    "full_source_download": false,
    "raw_code_download": false,
    "dependency_install": false,
    "unknown_code_execution": false,
    "source_mutation": false,
    "external_write": false,
    "secret_storage": false,
    "deployment": false,
    "desktop_runtime_activation": false,
    "runtime_activation": false,
    "adapter_activation": false,
    "tauri_command_invocation": false,
    "license_legal_approval": false,
    "adoption_authority": false,
    "formal_gate_replacement": false,
    "local_evidence_output_allowed": true,
    "requires_independent_review": true,
    "requires_rollback": true
  },
  "sources": {
    "config_path": "config/tauri-desktop-shell-source-readonly-probe.json",
    "config_sha256": "ca91871bf43844101d0e21f599bd506c8a2063d5c700f91aed1b3054d9d8f3a8",
    "adr_config_path": "config/tauri-desktop-shell-source-readonly-adr.json",
    "adr_config_sha256": "fd9cc9ac09496981a5f16df0e10b45f3a7a180cc7c6ce28d51d35fdf53fa1b4e",
    "adr_receipt_path": "artifacts/evidence/TAURI-DESKTOP-SHELL-SOURCE-READONLY-ADR-001/source-readonly-adr.receipt.json",
    "adr_receipt_sha256": "e4f9e196d09466e9eebea710d92a36bea81b0aa7bf311c97269444033b923d2b",
    "project_status_path": "config/aios-project-status.json",
    "project_status_sha256": "ce0d6c8c158c49a0544d7e3b04c41e3fe27304da6aa9a78eab76ce8b3a18e2b4"
  },
  "request_budget": {
    "allowed_hosts": [
      "api.github.com",
      "v2.tauri.app"
    ],
    "allowed_methods": [
      "GET",
      "HEAD"
    ],
    "max_total_requests": 8,
    "max_total_response_bytes": 250000,
    "max_response_bytes_per_request": 90000,
    "per_request_timeout_seconds": 15,
    "hard_timeout_seconds": 120,
    "max_concurrency": 1,
    "planned_requests": 8,
    "explicit_source_paths": 1
  },
  "planned_requests": [
    {
      "id": "tauri-repo-metadata",
      "method": "GET",
      "host": "api.github.com",
      "path": "/repos/tauri-apps/tauri",
      "url": "https://api.github.com/repos/tauri-apps/tauri",
      "resource_type": "repository-public-metadata",
      "body_policy": "hash-and-derived-summary-only",
      "directory_metadata_only": false,
      "body_stored": false
    },
    {
      "id": "tauri-language-metadata",
      "method": "GET",
      "host": "api.github.com",
      "path": "/repos/tauri-apps/tauri/languages",
      "url": "https://api.github.com/repos/tauri-apps/tauri/languages",
      "resource_type": "repository-language-public-metadata",
      "body_policy": "hash-and-derived-summary-only",
      "directory_metadata_only": false,
      "body_stored": false
    },
    {
      "id": "tauri-license-head",
      "method": "HEAD",
      "host": "api.github.com",
      "path": "/repos/tauri-apps/tauri/license",
      "url": "https://api.github.com/repos/tauri-apps/tauri/license",
      "resource_type": "license-endpoint-metadata-head-only",
      "body_policy": "no-body-read",
      "directory_metadata_only": false,
      "body_stored": false
    },
    {
      "id": "tauri-crate-directory-metadata",
      "method": "GET",
      "host": "api.github.com",
      "path": "/repos/tauri-apps/tauri/contents/crates/tauri?ref=dev",
      "url": "https://api.github.com/repos/tauri-apps/tauri/contents/crates/tauri?ref=dev",
      "resource_type": "source-directory-metadata",
      "body_policy": "hash-and-derived-directory-summary-only",
      "directory_metadata_only": true,
      "body_stored": false
    },
    {
      "id": "tauri-capabilities-docs",
      "method": "HEAD",
      "host": "v2.tauri.app",
      "path": "/security/capabilities/",
      "url": "https://v2.tauri.app/security/capabilities/",
      "resource_type": "official-documentation-page-head-only",
      "body_policy": "no-body-read",
      "directory_metadata_only": false,
      "body_stored": false
    },
    {
      "id": "tauri-permissions-docs",
      "method": "HEAD",
      "host": "v2.tauri.app",
      "path": "/security/permissions/",
      "url": "https://v2.tauri.app/security/permissions/",
      "resource_type": "official-documentation-page-head-only",
      "body_policy": "no-body-read",
      "directory_metadata_only": false,
      "body_stored": false
    },
    {
      "id": "tauri-filesystem-docs-head",
      "method": "HEAD",
      "host": "v2.tauri.app",
      "path": "/plugin/file-system/",
      "url": "https://v2.tauri.app/plugin/file-system/",
      "resource_type": "official-documentation-page-head-only",
      "body_policy": "no-body-read",
      "directory_metadata_only": false,
      "body_stored": false
    },
    {
      "id": "tauri-config-docs-head",
      "method": "HEAD",
      "host": "v2.tauri.app",
      "path": "/reference/config/",
      "url": "https://v2.tauri.app/reference/config/",
      "resource_type": "official-documentation-page-head-only",
      "body_policy": "no-body-read",
      "directory_metadata_only": false,
      "body_stored": false
    }
  ],
  "checks": [
    {
      "id": "adr_0053_is_accepted",
      "status": "pass"
    },
    {
      "id": "planned_requests_are_get_or_head_only",
      "status": "pass"
    },
    {
      "id": "planned_hosts_are_allowlisted_subset",
      "status": "pass"
    },
    {
      "id": "planned_request_count_within_budget",
      "status": "pass"
    },
    {
      "id": "total_response_bytes_within_budget",
      "status": "pass"
    },
    {
      "id": "no_raw_codeload_archive_tarball_zipball_git_locations",
      "status": "pass"
    },
    {
      "id": "directory_metadata_only_no_file_body_storage",
      "status": "pass"
    },
    {
      "id": "anonymous_public_requests_only",
      "status": "pass"
    },
    {
      "id": "response_bodies_not_stored",
      "status": "pass"
    },
    {
      "id": "headers_redacted",
      "status": "pass"
    },
    {
      "id": "license_is_observed_metadata_not_legal_approval",
      "status": "pass"
    },
    {
      "id": "mutating_external_effects_zero",
      "status": "pass"
    },
    {
      "id": "can_activate_now_false",
      "status": "pass"
    },
    {
      "id": "adoption_allowed_now_false",
      "status": "pass"
    },
    {
      "id": "terminal_receipt_or_invalid_required",
      "status": "pass"
    },
    {
      "id": "rollback_and_reviewer_required",
      "status": "pass"
    }
  ],
  "verdict": {
    "status": "pass-bounded-public-source-metadata-readonly-probe",
    "can_activate_now": false,
    "adoption_allowed_now": false,
    "license_approval": false,
    "next_gate": "TAURI-DESKTOP-SHELL-SOURCE-FINDINGS-UI-001"
  },
  "plan_fingerprint_sha256": "fec81afdc5348d6516425c8d5ddca5e6b9ad648f877112b92579bdb57b7c92c7",
  "completed_at_utc": "2026-07-29T20:01:00.682Z",
  "transport": "public-fetch",
  "progress": [
    {
      "status": "request-start",
      "request_id": "tauri-repo-metadata",
      "method": "GET",
      "url": "https://api.github.com/repos/tauri-apps/tauri"
    },
    {
      "status": "request-end",
      "request_id": "tauri-repo-metadata",
      "http_status": 200,
      "ok": true
    },
    {
      "status": "request-start",
      "request_id": "tauri-language-metadata",
      "method": "GET",
      "url": "https://api.github.com/repos/tauri-apps/tauri/languages"
    },
    {
      "status": "request-end",
      "request_id": "tauri-language-metadata",
      "http_status": 200,
      "ok": true
    },
    {
      "status": "request-start",
      "request_id": "tauri-license-head",
      "method": "HEAD",
      "url": "https://api.github.com/repos/tauri-apps/tauri/license"
    },
    {
      "status": "request-end",
      "request_id": "tauri-license-head",
      "http_status": 200,
      "ok": true
    },
    {
      "status": "request-start",
      "request_id": "tauri-crate-directory-metadata",
      "method": "GET",
      "url": "https://api.github.com/repos/tauri-apps/tauri/contents/crates/tauri?ref=dev"
    },
    {
      "status": "request-end",
      "request_id": "tauri-crate-directory-metadata",
      "http_status": 200,
      "ok": true
    },
    {
      "status": "request-start",
      "request_id": "tauri-capabilities-docs",
      "method": "HEAD",
      "url": "https://v2.tauri.app/security/capabilities/"
    },
    {
      "status": "request-end",
      "request_id": "tauri-capabilities-docs",
      "http_status": 200,
      "ok": true
    },
    {
      "status": "request-start",
      "request_id": "tauri-permissions-docs",
      "method": "HEAD",
      "url": "https://v2.tauri.app/security/permissions/"
    },
    {
      "status": "request-end",
      "request_id": "tauri-permissions-docs",
      "http_status": 200,
      "ok": true
    },
    {
      "status": "request-start",
      "request_id": "tauri-filesystem-docs-head",
      "method": "HEAD",
      "url": "https://v2.tauri.app/plugin/file-system/"
    },
    {
      "status": "request-end",
      "request_id": "tauri-filesystem-docs-head",
      "http_status": 200,
      "ok": true
    },
    {
      "status": "request-start",
      "request_id": "tauri-config-docs-head",
      "method": "HEAD",
      "url": "https://v2.tauri.app/reference/config/"
    },
    {
      "status": "request-end",
      "request_id": "tauri-config-docs-head",
      "http_status": 200,
      "ok": true
    }
  ],
  "responses": [
    {
      "request_id": "tauri-repo-metadata",
      "method": "GET",
      "url": "https://api.github.com/repos/tauri-apps/tauri",
      "final_url": "https://api.github.com/repos/tauri-apps/tauri",
      "status": 200,
      "ok": true,
      "redirected": false,
      "response_bytes": 6356,
      "response_sha256": "1fa0bb6c486a7866a5a45c72bd057caab224b72e321fb0564f3013100b2c04e1",
      "headers": {
        "cache-control": "public, max-age=60, s-maxage=60",
        "content-type": "application/json; charset=utf-8",
        "etag": "W/\"b7001d8f1c83c147099cc48347ec11ced3718e4d1dbc6963b53f15e04c66dc23\"",
        "last-modified": "Wed, 29 Jul 2026 19:34:44 GMT",
        "x-ratelimit-limit": "60",
        "x-ratelimit-remaining": "47"
      },
      "body_read": true,
      "body_stored": false,
      "body_logged": false,
      "derived_summary": {
        "full_name": "tauri-apps/tauri",
        "private": false,
        "visibility": "public",
        "archived": false,
        "disabled": false,
        "default_branch": "dev",
        "stargazers_count": 109660,
        "forks_count": 3814,
        "open_issues_count": 1428,
        "pushed_at": "2026-07-29T18:00:30Z",
        "license": {
          "key": "apache-2.0",
          "name": "Apache License 2.0",
          "spdx_id": "Apache-2.0"
        }
      }
    },
    {
      "request_id": "tauri-language-metadata",
      "method": "GET",
      "url": "https://api.github.com/repos/tauri-apps/tauri/languages",
      "final_url": "https://api.github.com/repos/tauri-apps/tauri/languages",
      "status": 200,
      "ok": true,
      "redirected": false,
      "response_bytes": 281,
      "response_sha256": "4729f85b792c8a74ff57eb96c4244496bc784186fdb7488fdd63352cf4942cd9",
      "headers": {
        "cache-control": "public, max-age=60, s-maxage=60",
        "content-type": "application/json; charset=utf-8",
        "etag": "W/\"e2f8b5a9dbc982cef737f1a11f733ea703c832612f235f15940dd19e8f100ae3\"",
        "last-modified": "Wed, 29 Jul 2026 19:34:44 GMT",
        "x-ratelimit-limit": "60",
        "x-ratelimit-remaining": "46"
      },
      "body_read": true,
      "body_stored": false,
      "body_logged": false,
      "derived_summary": {
        "language_count": 18,
        "languages": [
          {
            "language": "Rust",
            "share_percent": 83.6
          },
          {
            "language": "TypeScript",
            "share_percent": 6.5
          },
          {
            "language": "NSIS",
            "share_percent": 3.3
          },
          {
            "language": "Kotlin",
            "share_percent": 2
          },
          {
            "language": "JavaScript",
            "share_percent": 1.9
          },
          {
            "language": "Shell",
            "share_percent": 1.6
          },
          {
            "language": "Swift",
            "share_percent": 0.7
          },
          {
            "language": "Dockerfile",
            "share_percent": 0.1
          }
        ]
      }
    },
    {
      "request_id": "tauri-license-head",
      "method": "HEAD",
      "url": "https://api.github.com/repos/tauri-apps/tauri/license",
      "final_url": "https://api.github.com/repos/tauri-apps/tauri/license",
      "status": 200,
      "ok": true,
      "redirected": false,
      "response_bytes": 0,
      "response_sha256": "e3b0c44298fc1c149afbf4c8996fb92427ae41e4649b934ca495991b7852b855",
      "headers": {
        "cache-control": "public, max-age=60, s-maxage=60",
        "content-type": "application/json; charset=utf-8",
        "etag": "W/\"a5d1e86c2fb4c6bcc49d99107a35b247f3616b38ae7eb327392c5738cf0a9fc1\"",
        "last-modified": "Tue, 28 Jul 2026 09:01:37 GMT",
        "x-ratelimit-limit": "60",
        "x-ratelimit-remaining": "45"
      },
      "body_read": false,
      "body_stored": false,
      "body_logged": false,
      "derived_summary": {}
    },
    {
      "request_id": "tauri-crate-directory-metadata",
      "method": "GET",
      "url": "https://api.github.com/repos/tauri-apps/tauri/contents/crates/tauri?ref=dev",
      "final_url": "https://api.github.com/repos/tauri-apps/tauri/contents/crates/tauri?ref=dev",
      "status": 200,
      "ok": true,
      "redirected": false,
      "response_bytes": 9079,
      "response_sha256": "e1074c5f6bdb78fd8b299f751e1d47eb8053608b58405236da831bac0af04195",
      "headers": {
        "cache-control": "public, max-age=60, s-maxage=60",
        "content-type": "application/json; charset=utf-8",
        "etag": "\"9a28470aa7abd0a7b71e6ad35f1304e1b3993ad7\"",
        "last-modified": "Wed, 29 Jul 2026 19:34:44 GMT",
        "x-ratelimit-limit": "60",
        "x-ratelimit-remaining": "44"
      },
      "body_read": true,
      "body_stored": false,
      "body_logged": false,
      "derived_summary": {
        "directory_metadata_valid": true,
        "entry_count": 12,
        "returned_entry_count": 12,
        "type_counts": {
          "dir": 6,
          "file": 6
        },
        "entries": [
          {
            "name": ".scripts",
            "type": "dir",
            "size": 0,
            "sha_present": true
          },
          {
            "name": "CHANGELOG.md",
            "type": "file",
            "size": 441910,
            "sha_present": true
          },
          {
            "name": "Cargo.toml",
            "type": "file",
            "size": 7727,
            "sha_present": true
          },
          {
            "name": "LICENSE-APACHE-2.0",
            "type": "file",
            "size": 10174,
            "sha_present": true
          },
          {
            "name": "LICENSE-MIT",
            "type": "file",
            "size": 1090,
            "sha_present": true
          },
          {
            "name": "README.md",
            "type": "file",
            "size": 3517,
            "sha_present": true
          },
          {
            "name": "build.rs",
            "type": "file",
            "size": 15735,
            "sha_present": true
          },
          {
            "name": "mobile",
            "type": "dir",
            "size": 0,
            "sha_present": true
          },
          {
            "name": "permissions",
            "type": "dir",
            "size": 0,
            "sha_present": true
          },
          {
            "name": "scripts",
            "type": "dir",
            "size": 0,
            "sha_present": true
          },
          {
            "name": "src",
            "type": "dir",
            "size": 0,
            "sha_present": true
          },
          {
            "name": "test",
            "type": "dir",
            "size": 0,
            "sha_present": true
          }
        ],
        "body_contains_file_content": false,
        "body_contains_download_url": true
      }
    },
    {
      "request_id": "tauri-capabilities-docs",
      "method": "HEAD",
      "url": "https://v2.tauri.app/security/capabilities/",
      "final_url": "https://v2.tauri.app/security/capabilities/",
      "status": 200,
      "ok": true,
      "redirected": false,
      "response_bytes": 0,
      "response_sha256": "e3b0c44298fc1c149afbf4c8996fb92427ae41e4649b934ca495991b7852b855",
      "headers": {
        "cache-control": "public,max-age=0,must-revalidate",
        "content-type": "text/html; charset=UTF-8",
        "etag": "\"57eb3cdf43633f56141229023df89710-ssl-df\""
      },
      "body_read": false,
      "body_stored": false,
      "body_logged": false,
      "derived_summary": {}
    },
    {
      "request_id": "tauri-permissions-docs",
      "method": "HEAD",
      "url": "https://v2.tauri.app/security/permissions/",
      "final_url": "https://v2.tauri.app/security/permissions/",
      "status": 200,
      "ok": true,
      "redirected": false,
      "response_bytes": 0,
      "response_sha256": "e3b0c44298fc1c149afbf4c8996fb92427ae41e4649b934ca495991b7852b855",
      "headers": {
        "cache-control": "public,max-age=0,must-revalidate",
        "content-type": "text/html; charset=UTF-8",
        "etag": "\"ea562c2da26c5438f424918c1dde9f64-ssl-df\""
      },
      "body_read": false,
      "body_stored": false,
      "body_logged": false,
      "derived_summary": {}
    },
    {
      "request_id": "tauri-filesystem-docs-head",
      "method": "HEAD",
      "url": "https://v2.tauri.app/plugin/file-system/",
      "final_url": "https://v2.tauri.app/plugin/file-system/",
      "status": 200,
      "ok": true,
      "redirected": false,
      "response_bytes": 0,
      "response_sha256": "e3b0c44298fc1c149afbf4c8996fb92427ae41e4649b934ca495991b7852b855",
      "headers": {
        "cache-control": "public,max-age=0,must-revalidate",
        "content-type": "text/html; charset=UTF-8",
        "etag": "\"5c27e4c7bd34803b3290b0089ab0853d-ssl-df\""
      },
      "body_read": false,
      "body_stored": false,
      "body_logged": false,
      "derived_summary": {}
    },
    {
      "request_id": "tauri-config-docs-head",
      "method": "HEAD",
      "url": "https://v2.tauri.app/reference/config/",
      "final_url": "https://v2.tauri.app/reference/config/",
      "status": 200,
      "ok": true,
      "redirected": false,
      "response_bytes": 0,
      "response_sha256": "e3b0c44298fc1c149afbf4c8996fb92427ae41e4649b934ca495991b7852b855",
      "headers": {
        "cache-control": "public,max-age=0,must-revalidate",
        "content-type": "text/html; charset=UTF-8",
        "etag": "\"ef88b9cb5f715e7bb1e36d65662f5657-ssl-df\""
      },
      "body_read": false,
      "body_stored": false,
      "body_logged": false,
      "derived_summary": {}
    }
  ],
  "totals": {
    "planned_requests": 8,
    "completed_requests": 8,
    "ok_responses": 8,
    "failed_responses": 0,
    "total_response_bytes": 15716,
    "explicit_source_paths": 1,
    "source_directory_entries_observed": 12,
    "mutating_external_effects": 0
  },
  "public_findings": {
    "repository": {
      "full_name": "tauri-apps/tauri",
      "private": false,
      "visibility": "public",
      "archived": false,
      "disabled": false,
      "default_branch": "dev",
      "stargazers_count": 109660,
      "forks_count": 3814,
      "open_issues_count": 1428,
      "pushed_at": "2026-07-29T18:00:30Z",
      "license": {
        "key": "apache-2.0",
        "name": "Apache License 2.0",
        "spdx_id": "Apache-2.0"
      }
    },
    "languages": {
      "language_count": 18,
      "languages": [
        {
          "language": "Rust",
          "share_percent": 83.6
        },
        {
          "language": "TypeScript",
          "share_percent": 6.5
        },
        {
          "language": "NSIS",
          "share_percent": 3.3
        },
        {
          "language": "Kotlin",
          "share_percent": 2
        },
        {
          "language": "JavaScript",
          "share_percent": 1.9
        },
        {
          "language": "Shell",
          "share_percent": 1.6
        },
        {
          "language": "Swift",
          "share_percent": 0.7
        },
        {
          "language": "Dockerfile",
          "share_percent": 0.1
        }
      ]
    },
    "directory_metadata": {
      "path": "crates/tauri",
      "entry_count": 12,
      "type_counts": {
        "dir": 6,
        "file": 6
      },
      "entries": [
        {
          "name": ".scripts",
          "type": "dir",
          "size": 0,
          "sha_present": true
        },
        {
          "name": "CHANGELOG.md",
          "type": "file",
          "size": 441910,
          "sha_present": true
        },
        {
          "name": "Cargo.toml",
          "type": "file",
          "size": 7727,
          "sha_present": true
        },
        {
          "name": "LICENSE-APACHE-2.0",
          "type": "file",
          "size": 10174,
          "sha_present": true
        },
        {
          "name": "LICENSE-MIT",
          "type": "file",
          "size": 1090,
          "sha_present": true
        },
        {
          "name": "README.md",
          "type": "file",
          "size": 3517,
          "sha_present": true
        },
        {
          "name": "build.rs",
          "type": "file",
          "size": 15735,
          "sha_present": true
        },
        {
          "name": "mobile",
          "type": "dir",
          "size": 0,
          "sha_present": true
        },
        {
          "name": "permissions",
          "type": "dir",
          "size": 0,
          "sha_present": true
        },
        {
          "name": "scripts",
          "type": "dir",
          "size": 0,
          "sha_present": true
        },
        {
          "name": "src",
          "type": "dir",
          "size": 0,
          "sha_present": true
        },
        {
          "name": "test",
          "type": "dir",
          "size": 0,
          "sha_present": true
        }
      ],
      "body_contains_file_content": false,
      "body_contains_download_url": true
    },
    "docs": {
      "tauri-capabilities-docs": {},
      "tauri-permissions-docs": {}
    },
    "source_bodies_stored": false,
    "response_bodies_stored": false
  },
  "license_boundary": {
    "observed_license_key": "apache-2.0",
    "observed_license_spdx_id": "Apache-2.0",
    "status": "observed-public-metadata-only-not-legal-approval",
    "license_legal_approval": false,
    "adoption_allowed_now": false,
    "license_body_downloaded": false,
    "requires_human_license_review_before_adoption": true
  },
  "external_effects": {
    "read_only_public_requests": 8,
    "github_clones": 0,
    "full_source_downloads": 0,
    "raw_code_downloads": 0,
    "dependency_installs": 0,
    "unknown_code_executions": 0,
    "source_mutations": 0,
    "external_writes": 0,
    "secrets_stored": 0,
    "deployments": 0,
    "desktop_runtime_activations": 0,
    "runtime_activations": 0,
    "adapter_activations": 0,
    "tauri_command_invocations": 0
  },
  "fingerprint_sha256": "28610fdbd228ec43a65348eef3e1dc3448e25fa9419e4abe399a408ef8a549cb"
}
